import SectionHeader from '@Web/Src/Components/SectionHeader';
import Collapse from '@Web/Src/Components/Collapse';

function Faq({ data, title = '', desc = '', className = '' }) {
    return (
        <div className={`${className} text-dark mx-auto mt-20 w-full max-w-3xl`}>
            <SectionHeader
                type='dark'
                className='mx-auto mb-10 max-w-[550px]'
                icon='question'
                title={title}
                desc={desc}
            />
            {data.map((item, index) => {
                return (
                    <Collapse
                        key={index}
                        className='main-shadow small:p-4 mt-3 !rounded-3xl p-6 text-xl'
                        title={item.title}
                    >
                        <div>
                            {item.link ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.text.replace(
                                            ':link',
                                            `<a className="underline hover:opacity-90" href="${route(item.link)}" target="_blank" rel="noopener noreferrer">${item.linkWord}</a>`
                                        ),
                                    }}
                                />
                            ) : (
                                <div>{item.text}</div>
                            )}
                        </div>
                    </Collapse>
                );
            })}
        </div>
    );
}

export default Faq;
